import type { MessageKey } from '../en';

export const de: Partial<Record<MessageKey, string>> = {
  "defaults.accuracy.desc": "Genauigkeit für neue Verlaufspunkte",
  "defaults.accuracy.title": "Standard-GPS-Genauigkeit",
  "defaults.actual.desc": "Wird für die Ortssuche während der Simulation verwendet",
  "defaults.actual.empty": "Noch nicht gespeichert",
  "defaults.actual.emptyHint": "Erlaube den Standort und öffne die App ohne Simulation, um ihn zu erfassen.",
  "defaults.actual.pending": "Das Telefon speichert diesen Standort. Der Sync ist noch nicht verbunden.",
  "defaults.actual.refresh": "Jetzt aktualisieren",
  "defaults.actual.title": "Dein echter Standort",
  "defaults.browserChip": "Dieser Browser",
  "defaults.close": "Schließen",
  "defaults.color.desc": "Linienfarbe neuer Routen",
  "defaults.color.group": "Routenfarbe",
  "defaults.color.title": "Routenfarbe",
  "defaults.degrees": "{n}°",
  "defaults.format.dayMonthYear": "Datum, Jahr · 12 h",
  "defaults.format.dayShort": "Tag und Datum · 12 h",
  "defaults.format.eu": "EU-Datum · 24 h",
  "defaults.format.fullDay": "Volles Datum · 12 h",
  "defaults.format.iso": "ISO-Datum · 24 h",
  "defaults.format.monthFirst": "Monat zuerst · 24 h",
  "defaults.format.shortDayYear": "Tag, Datum, Jahr · 24 h",
  "defaults.format.timeFirst": "Zeit zuerst · 24 h",
  "defaults.format.us": "US-Datum · 12 h",
  "defaults.format.withSeconds": "Mit Sekunden · 12 h",
  "defaults.itinAccuracy.desc": "GPS-Genauigkeit neuer Routenabschnitte",
  "defaults.itinAccuracy.title": "Genauigkeit",
  "defaults.itinerary.desc": "Standards für neue Routenabschnitte",
  "defaults.itinerary.title": "Route",
  "defaults.joyAccuracy.desc": "Start-GPS-Genauigkeit beim Erstellen einer Joystick-Sitzung",
  "defaults.joyAccuracy.title": "Standard-GPS-Genauigkeit",
  "defaults.joyName.desc": "Standardname neuer Joystick-Sitzungen",
  "defaults.joyName.dialogTitle": "Namensformat der Sitzung wählen",
  "defaults.joyName.title": "Datumsformat",
  "defaults.joySpeed.desc": "Startgeschwindigkeit beim Erstellen einer Joystick-Sitzung",
  "defaults.joySpeed.title": "Standardgeschwindigkeit",
  "defaults.joyUnit.desc": "Zeigt und steuert Joystick-Geschwindigkeiten in km/h oder mph",
  "defaults.joystick.desc": "Standards für Joystick-Sitzungen",
  "defaults.joystick.title": "Joystick",
  "defaults.kilometers": "{n} km",
  "defaults.map.desc": "Wie neue Karten sich öffnen",
  "defaults.map.title": "Google Map",
  "defaults.mapTheme.desc": "Aussehen neuer Kartenbildschirme",
  "defaults.mapTheme.group": "Kartenthema",
  "defaults.mapTheme.title": "Kartenthema",
  "defaults.marker.car": "Auto",
  "defaults.marker.desc": "Wird beim Erstellen einer Joystick-Sitzung verwendet. Du kannst ihn je Sitzung ändern.",
  "defaults.marker.group": "Standardmarker",
  "defaults.marker.maps": "Maps",
  "defaults.marker.title": "Standardmarker",
  "defaults.marker.waze": "Waze",
  "defaults.meters": "{n} m",
  "defaults.nameFormat.desc": "Standardname für feste Punkte",
  "defaults.nameFormat.dialogSubtitle": "Die Vorschau nutzt das heutige Datum. Wähle ein kompaktes Format für neue Punkte.",
  "defaults.nameFormat.dialogTitle": "Namensformat für Punkte wählen",
  "defaults.nameFormat.group": "Datumsformat",
  "defaults.nameFormat.title": "Datumsformat",
  "defaults.overlay.itinerary.desc": "Schwebender Player, wenn die Routensimulation im Hintergrund weiterläuft",
  "defaults.overlay.itinerary.title": "Auto-Route",
  "defaults.overlay.joystick.desc": "Schwebender Joystick, wenn die Sitzung im Hintergrund weiterläuft",
  "defaults.overlay.joystick.title": "Joystick",
  "defaults.overlay.playlist.desc": "Schwebender Player, wenn die Listensimulation im Hintergrund weiterläuft",
  "defaults.overlay.playlist.title": "Liste",
  "defaults.overlay.stationary.desc": "Schwebender Player, wenn die feste Simulation im Hintergrund weiterläuft",
  "defaults.overlay.stationary.title": "Fester Punkt",
  "defaults.plAccuracy.desc": "GPS-Genauigkeit für jeden Listen-Pin",
  "defaults.plAccuracy.title": "Genauigkeit pro Eintrag",
  "defaults.player.desc": "Steuerung für Overlay-Player und Simulation",
  "defaults.player.title": "Player",
  "defaults.playlist.desc": "Standards für neue Listen-Pins",
  "defaults.playlist.title": "Liste",
  "defaults.polyline.desc": "Standardfarbe der Route, die während einer Joystick-Sitzung gezeichnet wird.",
  "defaults.polyline.group": "Polylinienfarbe",
  "defaults.polyline.title": "Standardfarbe der Polylinie",
  "defaults.range.accuracyMax": "300 m",
  "defaults.range.accuracyMin": "0 m",
  "defaults.range.itinAccuracyMax": "100",
  "defaults.range.itinAccuracyMin": "1",
  "defaults.range.joyAccuracyMax": "100 m",
  "defaults.range.joyAccuracyMin": "1 m",
  "defaults.range.plAccuracyMax": "500 m",
  "defaults.range.plAccuracyMin": "0 m",
  "defaults.range.searchMax": "50 km",
  "defaults.range.searchMin": "3 km",
  "defaults.range.tiltMax": "65°",
  "defaults.range.tiltMin": "0°",
  "defaults.range.timeMax": "600 Sek.",
  "defaults.range.timeMin": "0 Sek.",
  "defaults.range.zoomMax": "20",
  "defaults.range.zoomMin": "10",
  "defaults.reset": "Zurücksetzen",
  "defaults.search.itinerary": "Nahe Ergebnisse rund um die Kartenmitte werden bevorzugt",
  "defaults.search.playlist": "Nahe Ergebnisse rund um die Kartenmitte werden bevorzugt",
  "defaults.search.stationary": "Nahe Ergebnisse rund um deinen Pin werden bevorzugt",
  "defaults.search.title": "Suchradius",
  "defaults.seconds": "{n} Sek.",
  "defaults.section.appearance": "Darstellung",
  "defaults.section.camera": "Kamera",
  "defaults.section.history": "Verlauf",
  "defaults.section.location": "Standortkontext",
  "defaults.section.map": "Karte",
  "defaults.section.motion": "Bewegung",
  "defaults.section.overlay": "Overlay-Player",
  "defaults.section.playlist": "Liste",
  "defaults.section.search": "Suche",
  "defaults.section.style": "Stil",
  "defaults.section.view": "Karte",
  "defaults.sectionDefaults": "App-Standards",
  "defaults.sectionDefaultsDesc": "Lege Standards für ein schnelleres und ruhigeres Erlebnis fest",
  "defaults.sectionPlayer": "Player",
  "defaults.sectionPlayerDesc": "Einstellungen für Overlay und Wiedergabe",
  "defaults.speed.desc": "Wiedergabegeschwindigkeit neuer Routenabschnitte",
  "defaults.speed.title": "Standardgeschwindigkeit",
  "defaults.speedValue": "{n} {unit}",
  "defaults.stationary.desc": "Standards für neue Kartenpunkte",
  "defaults.stationary.title": "Fester Punkt",
  "defaults.summary.playerAll": "Alle Overlays an",
  "defaults.summary.playerOff": "Overlays aus",
  "defaults.summary.playerSome": "{on} von 4 an",
  "defaults.summary.zoom": "Zoom {n}",
  "defaults.syncNote": "Vorerst in diesem Browser gespeichert. Die Telefon-App übernimmt diese Werte, sobald der Sync verbunden ist.",
  "defaults.theme.night": "Nacht",
  "defaults.theme.nightDesc": "Dunkle Kartenfarben für wenig Licht und Nachtsitzungen.",
  "defaults.theme.retro": "Retro",
  "defaults.theme.retroDesc": "Warme Vintage-Töne mit klassischem Kartengefühl.",
  "defaults.theme.silver": "Silber",
  "defaults.theme.silverDesc": "Helles Grau, angenehm bei Tageslicht.",
  "defaults.theme.standard": "Standard",
  "defaults.theme.standardDesc": "Klassische Google-Maps-Farben mit vertrautem Grün und Blau.",
  "defaults.tilt.desc": "Kamerawinkel auf Kartenbildschirmen",
  "defaults.tilt.title": "Standard-Kameraneigung",
  "defaults.time.desc": "Wartezeit, bevor der nächste Pin kommt",
  "defaults.time.title": "Zeit pro Eintrag",
  "defaults.tray.group": "Leistenhöhe",
  "defaults.tray.large": "Groß",
  "defaults.tray.medium": "Mittel",
  "defaults.tray.playlistDesc": "Sichtbares Listenpanel auf der Karte",
  "defaults.tray.small": "Klein",
  "defaults.tray.stationaryDesc": "Sichtbare Panelgröße auf der Karte",
  "defaults.tray.title": "Leistenhöhe",
  "defaults.unit.group": "Geschwindigkeitseinheit",
  "defaults.unit.itineraryDesc": "Zeigt Geschwindigkeiten im Routenmodul als km/h oder mph",
  "defaults.unit.kmh": "km/h",
  "defaults.unit.mph": "mph",
  "defaults.unit.title": "Geschwindigkeitseinheit",
  "defaults.view.grid": "Raster",
  "defaults.view.group": "Ansicht",
  "defaults.view.historyDesc": "Wie gespeicherte Punkte angezeigt werden",
  "defaults.view.historyTitle": "Verlaufsansicht",
  "defaults.view.list": "Liste",
  "defaults.view.playlistDesc": "Wie gespeicherte Listen angezeigt werden",
  "defaults.view.playlistTitle": "Listenansicht",
  "defaults.zoom.desc": "Startzoom für neue Karten",
  "defaults.zoom.title": "Standard-Zoomstufe",
  "language.defaultBadge": "Standard",
  "language.empty": "Keine Sprache passt zu dieser Suche.",
  "language.lead": "Englisch (Vereinigte Staaten) ist die Standardsprache. Deine Wahl bleibt in diesem Browser gespeichert.",
  "language.listLabel": "Sprachen",
  "language.preview": "Simulierte Standorte, Listen und Routen.",
  "language.previewLabel": "Vorschau",
  "language.searchLabel": "Sprachen suchen",
  "language.searchPlaceholder": "Sprachen suchen",
  "nav.account": "Konto",
  "nav.account.desc": "Profil, Premium und Anmeldedaten.",
  "nav.analytics": "Analysen",
  "nav.analytics.desc": "Verstehe deine MockLoc-Aktivität, die Netzwerknutzung und den Sync-Zustand.",
  "nav.articles": "Artikel",
  "nav.articles.desc": "Anleitungen zu Einrichtung, Wiedergabe und Sync.",
  "nav.backup": "Sicherung und Sync",
  "nav.backup.desc": "Status von Cloud-Sicherung und Synchronisierung.",
  "nav.coins": "Mock Coins",
  "nav.coins.desc": "Vollständige Aufschlüsselung der Münznutzung nach Modul und Aktivität.",
  "nav.dashboard": "Übersicht",
  "nav.dashboard.desc": "Überblick über Standorte, Listen, Routen und Kontoaktivität.",
  "nav.devices": "Geräte verwalten",
  "nav.devices.desc": "Prüfe Geräte, die bei deinem MockLoc-Konto angemeldet sind.",
  "nav.help": "Hilfe und Support",
  "nav.help.desc": "Verfolge Gespräche und hole dir Hilfe vom MockLoc-Team.",
  "nav.history": "Standortverlauf",
  "nav.history.desc": "Orte, die dieses Konto simuliert hat.",
  "nav.itinerary": "Routen",
  "nav.itinerary.desc": "Erstelle, bearbeite und verwalte deine gespeicherten Routen.",
  "nav.joystick": "Joystick-Sitzungen",
  "nav.joystick.desc": "Wiedergaberouten, Statistiken und gespeicherte Joystick-Sitzungen.",
  "nav.notifications": "Benachrichtigungen",
  "nav.notifications.desc": "Hinweise zu Sync, Sicherung und Produkt.",
  "nav.playlist": "Listen",
  "nav.playlist.desc": "Geordnete Gruppen simulierter Standorte.",
  "nav.settings": "Einstellungen",
  "nav.settings.desc": "Thema, Sprache und Standardwerte der mobilen App.",
  "nav.stationary": "Feste Punkte",
  "nav.stationary.desc": "Feste simulierte Standorte, die auf diesem Konto gespeichert sind.",
  "nav.whatsNew": "Neu in der App",
  "nav.whatsNew.desc": "Neue Updates, Korrekturen und Verbesserungen in MockLoc.",
  "settings.back": "Einstellungen",
  "settings.backDefaults": "Standardwerte der App",
  "settings.defaults.shellDesc": "Werte, die die Telefon-App für Karten, Punkte, Routen und Wiedergabe nutzt.",
  "settings.defaults.shellTitle": "Standardwerte der App",
  "settings.home.defaults.desc": "Karten-, Punkt-, Listen-, Routen-, Joystick- und Player-Standards aus der Telefon-App.",
  "settings.home.defaults.title": "Standardwerte der App",
  "settings.home.language.desc": "Wähle die Sprache für Menü, Seitentitel und Einstellungen.",
  "settings.home.language.title": "Spracheinstellungen",
  "settings.home.theme.desc": "Textgröße, Farben, hell oder dunkel und Schrift für diesen Browser.",
  "settings.home.theme.title": "Themeneinstellungen",
  "settings.language.shellDesc": "Wähle die Sprache dieser Website.",
  "settings.language.shellTitle": "Sprache",
  "settings.theme.shellDesc": "Textgröße, Farben, hell oder dunkel und Schrift für diesen Browser.",
  "settings.theme.shellTitle": "Thema",
  "shell.account": "Konto",
  "shell.accountMenu": "Kontomenü",
  "shell.accountMenuNamed": "Kontomenü, {name}",
  "shell.closeMenu": "Menü schließen",
  "shell.collapseSidebar": "Seitenleiste einklappen",
  "shell.dashboardSubtitle": "Verwalte simulierte Standorte, Listen, Routen und mehr an einem Ort.",
  "shell.devicesLimit": "Nutzung auf bis zu 3 Geräten",
  "shell.expandSidebar": "Seitenleiste ausklappen",
  "shell.goPremium": "Premium holen",
  "shell.logOut": "Abmelden",
  "shell.mainNav": "Hauptmenü",
  "shell.noMatches": "Keine Treffer",
  "shell.notifications": "Benachrichtigungen",
  "shell.notificationsUnread": "Benachrichtigungen, {count} ungelesen",
  "shell.openMenu": "Menü öffnen",
  "shell.pages": "Seiten",
  "shell.recent": "Zuletzt",
  "shell.searchLabel": "Standorte, Listen, Routen, Artikel suchen",
  "shell.searchPlaceholder": "Standorte, Listen, Routen, Artikel suchen...",
  "shell.searchResults": "Suchergebnisse",
  "shell.tagline": "Simulierter Standort, einfach gemacht",
  "shell.themeDarkTitle": "Dunkles Thema",
  "shell.themeLightTitle": "Helles Thema",
  "shell.themeToDark": "Zum dunklen Thema wechseln",
  "shell.themeToLight": "Zum hellen Thema wechseln",
  "shell.there": "du",
  "shell.unlimitedCoins": "Unbegrenzte Münzen",
  "shell.unlimitedEverything": "Alles unbegrenzt",
  "shell.upgradeNow": "Jetzt upgraden",
  "shell.viewAllNotifications": "Alle Benachrichtigungen anzeigen",
  "shell.welcome": "Willkommen zurück, {name}!",
  "theme.builtin": "Eingebaut",
  "theme.changesLabel": "Was sich ändert.",
  "theme.color.accent.changes": "Markengold und blasse Goldflächen, auch kleine Illustrationsdetails.",
  "theme.color.accent.title": "Akzent",
  "theme.color.accent.where": "Goldene Akzente bei Anmeldung, Artikeln und Abzeichen.",
  "theme.color.danger.changes": "Roter Fehlertext und zerstörende Aktionen.",
  "theme.color.danger.title": "Gefahr",
  "theme.color.danger.where": "Fehler, Entfernen und der Ungelesen-Punkt.",
  "theme.color.info.changes": "Das Blau für Informationen in hell und dunkel.",
  "theme.color.info.title": "Info",
  "theme.color.info.where": "Blauer Status, Infotext-Links und Infomarken.",
  "theme.color.lead": "Eingebaute Farben bleiben in hell und dunkel verschieden, bis du eine wählst. Deine Wahl gilt in beiden Themen. Farben, die an einem Punkt, einer Liste oder einer Route gespeichert sind, bleiben gespeichert.",
  "theme.color.primary.changes": "Kräftiges Violett, blassvioletter Text und weiche violette Flächen.",
  "theme.color.primary.title": "Primär",
  "theme.color.primary.where": "Schaltflächen, aktiver Menüpunkt, Links und Markenviolett.",
  "theme.color.success.changes": "Grüner Statustext und Erfolgsmarken.",
  "theme.color.success.title": "Erfolg",
  "theme.color.success.where": "Synchronisiert, abgeschlossen und positiver Status.",
  "theme.color.title": "Farbe",
  "theme.color.warning.changes": "Bernstein-Warnungen und das Gold der Münzen.",
  "theme.color.warning.title": "Warnung",
  "theme.color.warning.where": "Hinweise, Münzmarken und Premium-Akzente.",
  "theme.colorAria": "Farbe {title}",
  "theme.custom": "Eigen",
  "theme.face.arialBold": "Arial Bold",
  "theme.face.arialRegular": "Arial Regular",
  "theme.face.arialSynth": "Aus Arial erzeugt",
  "theme.face.gsBold": "Google Sans Bold",
  "theme.face.gsRegular": "Google Sans Regular",
  "theme.face.helveticaOther": "Helvetica oder erzeugt",
  "theme.face.helveticaRegular": "Helvetica Regular",
  "theme.face.inter": "Inter {weight}",
  "theme.font.arial.note": "Regular und Bold sind installierte Schnitte. Andere Stärken werden erzeugt.",
  "theme.font.google-sans.note": "Die Regular-Datei deckt 400 und 500 ab. Die Bold-Datei deckt 600 bis 900 ab.",
  "theme.font.group": "Schrift",
  "theme.font.helvetica.note": "Nutzt Helvetica auf diesem Gerät, dann Helvetica Neue, dann Arial.",
  "theme.font.inter.note": "Schrift, die die Website heute nutzt. Regular bis Black sind geladen.",
  "theme.font.lead": "Eine Schriftfamilie gilt für die ganze Website. Marketing-Überschriften nutzen wieder Plus Jakarta Sans, wenn Inter gewählt ist. Die Schnitte unten sind die, die die Oberfläche schon nutzt.",
  "theme.font.sample": "Simulierter Standort, einfach",
  "theme.font.title": "Schrift",
  "theme.hexAria": "Hex {title}",
  "theme.lead": "Wähle Textgröße, Farbe, hell oder dunkel und die Schrift für diesen Browser. 100 % entspricht den heutigen Bildschirmen. Die Beispiele hier und der Rest der Website ändern sich zusammen.",
  "theme.manager": "Themenverwaltung",
  "theme.mode.dark": "Dunkel",
  "theme.mode.darkHint": "Dunkle Flächen und heller Text.",
  "theme.mode.group": "Thema",
  "theme.mode.lead": "Dieselbe Hell- und Dunkelwahl wie die Schaltfläche in der oberen Leiste.",
  "theme.mode.light": "Hell",
  "theme.mode.lightHint": "Helle Flächen und dunkler Text.",
  "theme.mode.title": "Thema",
  "theme.previewBody": "Gespeicherte Standorte auf diesem Konto.",
  "theme.previewBold": "Liste bereit",
  "theme.previewHelp": "Geordnete Gruppen simulierter Standorte.",
  "theme.previewKicker": "Live-Vorschau",
  "theme.previewTitle": "Simulierte Standorte",
  "theme.reset": "Zurücksetzen",
  "theme.resetAll": "Alles zurücksetzen",
  "theme.resetColors": "Farben zurücksetzen",
  "theme.resetFont": "Schrift zurücksetzen",
  "theme.resetText": "Text zurücksetzen",
  "theme.sizeAria": "Größe von {title}",
  "theme.text.bold.changes": "Text von 15 px bis 18 px.",
  "theme.text.bold.sample": "Premium holen",
  "theme.text.bold.title": "Fett",
  "theme.text.bold.where": "Kartentitel, Markenname, Abschnittsüberschriften und große Schaltflächen.",
  "theme.text.descriptive.changes": "Text von 12 px bis 13 px.",
  "theme.text.descriptive.sample": "Geordnete Gruppen simulierter Standorte.",
  "theme.text.descriptive.title": "Beschreibend",
  "theme.text.descriptive.where": "Untertitel, Hilfetext, Abzeichen, Fußzeilen und Nebenzeilen.",
  "theme.text.header.changes": "Text ab 20 px.",
  "theme.text.header.sample": "Feste Punkte",
  "theme.text.header.title": "Kopfzeile",
  "theme.text.header.where": "Seitentitel, große Überschriften, Titel leerer Zustände und große Zahlen wie Münzstände.",
  "theme.text.lead": "Jede Rolle hat eine gemeinsame Größe. Das Beispiel zeigt diese Rolle. Die Regler auf dieser Seite bleiben fest groß, damit sie leicht bedienbar bleiben.",
  "theme.text.normal.changes": "Text mit 14 px.",
  "theme.text.normal.sample": "Gespeicherte Standorte auf diesem Konto.",
  "theme.text.normal.title": "Normal",
  "theme.text.normal.where": "Navigationsbeschriftungen, normale Schaltflächen, Listentitel und kurze Zusammenfassungen.",
  "theme.text.other.changes": "Text von 9 px bis 11 px. Marken unter 9 px bleiben fest.",
  "theme.text.other.sample": "Vor 2 Stunden aktualisiert",
  "theme.text.other.title": "Sonstiges",
  "theme.text.other.where": "Kleine Beschriftungen, Zeitstempel, Diagrammbeschriftungen und Bildunterschriften.",
  "theme.text.title": "Text",
  "theme.weight.black": "Black",
  "theme.weight.bold": "Bold",
  "theme.weight.extrabold": "Extra bold",
  "theme.weight.medium": "Medium",
  "theme.weight.regular": "Regular",
  "theme.weight.sample": "Simulierte Standorte, Listen und Routen",
  "theme.weight.semibold": "Semibold",
  "theme.whereLabel": "Wo es verwendet wird.",
};
